import { render } from "./NoticeListForm.vue?vue&type=template&id=457a0088"
import script from "./NoticeListForm.vue?vue&type=script&lang=js"
export * from "./NoticeListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__